<script setup lang="ts">
// Shown in place of the generic "could not load the registry" error when the
// registrar has no GitHub PAT configured: the load can never succeed until a
// token is set. Only someone who can reach the admin-only Settings page can fix
// it — an admin, or the unconfigured first-run operator who has no identity yet
// — which is exactly `authStore.canAccessSettings`, the same rule the router's
// Settings guard enforces. Those visitors get the actionable "Open Settings"
// link; a signed-in non-admin (a member) is instead told an administrator must
// set the token, with no dead-end link to a page they cannot open.
import { useAuthStore } from '@/features/auth/authStore';

const auth = useAuthStore();
</script>

<template>
  <section class="setup-notice" data-testid="setup-notice" role="status">
    <template v-if="auth.canAccessSettings">
      <h2>Connect a GitHub token to load the registry</h2>
      <p class="text-muted">
        This registrar needs a GitHub personal access token to read the
        repository. Set one in Settings to load the registry.
      </p>
      <RouterLink
        class="btn btn-primary"
        to="/settings"
        data-testid="setup-notice-link"
      >
        Open Settings
      </RouterLink>
    </template>
    <template v-else>
      <h2>This registrar isn't ready yet</h2>
      <p class="text-muted">
        This registrar needs a GitHub personal access token to read the
        repository. An administrator must set one in Settings.
      </p>
    </template>
  </section>
</template>

<style scoped>
.setup-notice {
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
  padding: 3rem 1rem;
}

.setup-notice h2 {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.setup-notice p {
  margin-bottom: 1.25rem;
}
</style>
